<div class="row" *ngIf="loading">
  <div class="col">
    <div class="alert alert-warning">Loading... <app-spin-icon></app-spin-icon>
    </div>
  </div>
</div>
<div class="row" *ngIf="!loading">
  <div class="col">
    <div class="row">
      <div class="card card-cascade wider col-md-10 col-lg-8 col-12 mb-3 ml-auto mr-auto" *ngFor="let subscription of Billing.subscriptions">
        <div class="view gradient-card-header secondary-gradient">
          <h4>{{subscription.plan?.name}}</h4>
        </div>

        <div class="card-body text-center light-text" *ngIf="canceling">
          <div *ngIf="cancelConfirm">
            <h4>
              We're sorry to see you go!
            </h4>
            <div>
              <h5>I am cancelling because...</h5>
              <ul class="text-left list-group">
                <li class="list-group-item" *ngFor="let reason of cancellationReasons">
                  <input type="radio" value="reason.id" class="form-control" (click)="setCancelReason(reason.id)" [checked]="isCancelChecked(reason.id)">
                  <label for="reason.id" class="form-check-label" (click)="setCancelReason(reason.id)">{{reason.label}}</label>
                </li>
                <li class="list-group-item">
                  <input type="radio" id="cancel-other" class="form-control" [checked]="isCancelChecked('Other')" (click)="setCancelReason('Other')">
                  <label for="cancel-other" (click)="setCancelReason('Other')"><input #cancelOtherReason type="text" placeholder="Other...." class="form-control" /></label>
                </li>
              </ul>
              <p class="alert alert-warning">
                We want to make you aware that by cancelling your membership subscription, your clients and all other user accounts connected with this subscription will have their access terminated at 
                the end of your billing period.  You will continue to have services and access to your account data until <b>{{subscription.currentPeriodEnd|date:'mediumDate'}}</b>.
                For more information regarding membership subscription cancellation refer to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>.
              </p>
              <input type="button" value="Keep Subscription" class="btn btn-success" (click)="keepSubscription(subscription)" />
              <input type="button" value="Cancel Subscription" class="btn btn-danger" (click)="cancelSubscription(subscription)" [disabled]="!hasCancelReason()" />
            </div>
          </div>
        </div>

        <div class="card-body text-center light-text" *ngIf="!canceling">

          <h4>{{subscription.getChargeDescription()}}</h4>

          <div class="text-left" *ngIf="subscription.status == 'cancel-processing'">
            <div class="text-center">
              <div class="pt-2"><p class="alert alert-warning">You will continue to have access to the service and all of your account data under this membership subscription until <b>{{subscription.currentPeriodEnd|date:'mediumDate'}}</b>.</p></div>
            </div>
            <p>Your cancellation request has been submitted and will be processed by our team within the next available business day.
              Any outstanding account balance will be submitted to the contact information we have on file for you.</p>
            <p>If this is your only active membership subscription with us your account will be terminated in accordance with our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a></p>
            <p>For questions about your account cancellation or billing please contact us at {{supportEmail}}.</p>
            <p>For more information regarding account cancellation refer to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>.</p>
          </div>

          <div *ngIf="subscription.status == 'active'">
            <h6>Your credit card will be charged {{subscription.total|currency}} on
              {{subscription.renewalDate|date:'mediumDate'}}</h6>
            <div class="text-center">
              <div class="pt-2"><p class="alert alert-warning">If you cancel your membership subscription you will have services
                  until
                  {{subscription.currentPeriodEnd|date:'mediumDate'}}</p></div>
            </div>
            <h5><b>Included in this plan</b></h5>
            <ul class="text-left list-group mb-2">
              <li class="list-group-item" *ngFor="let planItem of getPlanItems(subscription)"><i class="fa fa-check text-success pr-3"></i>{{planItem}}</li>
            </ul>
            <div class="text-center">
              <p>If you no longer wish to continue your subscription you may cancel by pressing the button below.</p>
              <input type="button" class="btn btn-danger" value="Cancel Subscription" (click)="startCancellation(subscription)" />
            </div>
            <p>
              If you have questions about or need help changing your membership subscription please contact us at {{supportEmail}}.
            </p>
          </div>

          <!-- trial subscription-->
          <div class="text-center" *ngIf="subscription.status == 'trialing'">
            <input type='button' *ngIf="!upgrading" value="Upgrade Membership" class="btn btn-success btn-lg" (click)="upgradeTrialSubscription(subscription)" />
            <button class="btn btn-info btn-lg" disabled *ngIf="upgrading">Upgrading...</button><app-spin-icon *ngIf="upgrading"></app-spin-icon>
            <p class="alert alert-danger" *ngIf="subscriptionAlertMessage">
              We ran into problems upgrading your membership subscription.  This can occur due to a problem with your billing card or in attempting to
              communicating with our servers. You can resolve this by choosing a valid billing card, contacting
              your card provider, or trying to upgrade later.  If you continue to have issues contact our support team.  The specific error returned was:<br />
              <b>{{subscriptionAlertMessage}}</b>
            </p>
            <h3>Only <b class="text-success">{{subscription.plan.amountPerUnit|currency}}</b> per
              {{subscription.plan.getSingularUnitType()|lowercase}} per {{subscription.billingInterval}}</h3>
            <p class='alert alert-warning'>Your membership trial period
              will end on <b class="text-red">{{subscription.currentPeriodEnd|date:'mediumDate'}}</b>.</p>
            <p class="text-left">By upgrading your membership subscription plan you will be asked to provide a valid billing
              credit card for your account.
              Upon adding your card, your billing card will be immediately charged by {{stripeChargeName}} for a total of
              <b>{{subscription.total|currency}}</b> for {{subscription.quantity}} {{subscription.plan.getUnitTypeNameForQuantity(subscription.quantity)}}.
              
              Your membership subscription will be renewed on each subsequent {{subscription.billingInterval}} until you cancel.
              You will be able to cancel your subscription at any point in time on this page or by contacting 
              us at our support email.

              For more information refer to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a></p>
              <h5><b>Included in this plan</b></h5>
              <ul class="text-left list-group mb-2">
                <li class="list-group-item" *ngFor="let planItem of getPlanItems(subscription)"><i class="fa fa-check text-success pr-3"></i>{{planItem}}</li>
              </ul>
              <div class="text-center">
                <p>If you no longer wish to continue your free trial you may cancel by pressing the button below.</p>
                <input type="button" class="btn btn-danger" value="Cancel Subscription" (click)="startCancellation(subscription)" />
              </div>
              <p>
                If you have questions about or need help changing your membership subscription please contact us at {{supportEmail}}.
              </p>
          </div>

          <!-- trial-ended subscription-->
          <div class="text-center" *ngIf="subscription.status == 'trial-ended'">
            <input type='button' *ngIf="!upgrading" value="Upgrade Membership" class="btn btn-success btn-lg" (click)="updatePastDueBillingDetails(subscription)" />
            <button class="btn btn-info btn-lg" disabled *ngIf="upgrading">Upgrading...</button><app-spin-icon *ngIf="upgrading"></app-spin-icon>
            <p class="alert alert-danger" *ngIf="subscriptionAlertMessage">
              We ran into problems upgrading your membership subscription.  This can occur due to a problem with your billing card or in attempting to
              communicating with our servers. You can resolve this by choosing a valid billing card, contacting
              your card provider, or trying to upgrade later.  If you continue to have issues contact our support team.  The specific error returned was:<br />
              <b>{{subscriptionAlertMessage}}</b>
            </p>
            <h3>Only <b class="text-success">{{subscription.plan.amountPerUnit|currency}}</b> per
              {{subscription.plan.getSingularUnitType()|lowercase}} per {{subscription.billingInterval}}</h3>
            <p class='alert alert-danger'>
              Your membership subscription trial period ended on <b class="text-red">{{subscription.currentPeriodEnd|date:'mediumDate'}}</b>.
              To continue full use of your membership upgrade today.
            </p>
            <p class="text-left">By upgrading your membership subscription plan you will be asked to provide a valid billing
              credit card for your account.
              Upon adding your card, your billing card will be immediately charged by {{stripeChargeName}} for a total of
              <b>{{subscription.total|currency}}</b> for {{subscription.quantity}} {{subscription.plan.getUnitTypeNameForQuantity(subscription.quantity)}}.
              
              Your membership subscription will be renewed on each subsequent {{subscription.billingInterval}} until you cancel.
              You will be able to cancel your subscription at any point in time on this page or by contacting 
              us at our support email.

              For more information refer to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a></p>
              <h5><b>Included in this plan</b></h5>
              <ul class="text-left list-group mb-2">
                <li class="list-group-item" *ngFor="let planItem of getPlanItems(subscription)"><i class="fa fa-check text-success pr-3"></i>{{planItem}}</li>
              </ul>
              <p>
                If you have questions about or need help changing your membership subscription please contact us at {{supportEmail}}.
              </p>
          </div>

          <!-- past-due subscription-->
          <div class="text-center" *ngIf="subscription.isUnpaidSubscription()">
            <h6>Past due balance of {{subscription.total|currency}} due on
              {{subscription.renewalDate|date:'mediumDate'}}</h6>
            <div class="alert alert-danger">
              <p>We've made several attempts to charge your billing card on file.  Please update your card to avoid having
              your membership subscription canceled.  Failure to update your billing card will result in the termination of your account 
              in accordance with our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>.</p>
              <div *ngIf="subscriptionAlertMessage">
                <p *ngIf="subscriptionAlertMessage"><b>Payment Failed</b></p>
                <hr />
                <p *ngIf="subscriptionAlertMessage">{{subscriptionAlertMessage}}</p>
              </div>
            </div>
            <input type='button' *ngIf="!upgrading" value="Update Billing Card" class="btn btn-success btn-lg" (click)="updatePastDueBillingDetails(subscription)" />
            <button class="btn btn-info btn-lg" disabled *ngIf="upgrading">Processing...</button><app-spin-icon *ngIf="upgrading"></app-spin-icon>
            <p>Updating your billing card will charge your account for the past due balance of <b>{{subscription.total|currency}}</b> 
              for {{subscription.quantity}} {{subscription.plan.getUnitTypeNameForQuantity(subscription.quantity)}}.</p>

              <!-- TODO: stephen If after 15-20 seconds we couldn't get a status update that the subscription had become active
                   We need to display a message that the system is processing the card and to check back in 1-2 hours
                   to verify their payment credentials were valid.
              -->
            <h5><b>Included in this plan</b></h5>
            <ul class="text-left list-group mb-2">
              <li class="list-group-item" *ngFor="let planItem of getPlanItems(subscription)"><i class="fa fa-check text-success pr-3"></i>{{planItem}}</li>
            </ul>
            <p>
              If you have questions about or need help changing your membership subscription plan please contact us at {{supportEmail}}.
            </p>
          </div>
          <!-- Terminated-->
          <div class="text-center" *ngIf="subscription.isEndedSubscription()">
            <p class="alert alert-warning">Your membership subscription was terminated on {{subscription.endedAt|date:'mediumDate'}}.
              Contact {{supportEmail}} to discuss options for renewing your membership subscription. Your account access and client data will no longer be available after
              <b>{{subscription.currentPeriodEnd|date:'mediumDate'}}</b>.
              For more information refer to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>
            </p>
            <h5><b>What was included in this plan</b></h5>
            <ul class="text-left list-group mb-2">
              <li class="list-group-item" *ngFor="let planItem of getPlanItems(subscription)"><i class="fa fa-check text-success pr-3"></i>{{planItem}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Old customers with no subscription option-->
    <div class="row pl-4 pt-4" *ngIf="!Billing.hasSubscriptions()">
      <div class="col">
        <p>If you are interested in a monthly unlimited membership subscription plan.  Contact {{supportEmail}} to have your account migrated to a 
          subscription plan!
        </p>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/billing-plans/billing-plans.component.html